export default {
  en: {
    sectionProfile: 'Profile',
    name: 'Name',
    nameRequired: 'Enter a name',
    nameSaveError: 'Couldn’t save. Please try again.',
    save: 'Save',
    sectionConnections: 'Connections',
    telegramConnect: 'Connect Telegram',
    telegramConnected: 'Telegram connected',
    title: 'Settings',
    sectionLanguage: 'Language',
    interfaceLanguage: 'Interface language',
    english: 'English',
    russian: 'Русский',
    german: 'Deutsch',
    portuguese: 'Português',
    french: 'Français',
    spanish: 'Español',
    translationLanguage: 'Translation & explanations',
    translationLanguageHint: 'Used for message translations and error explanations.',
    sectionLearning: 'Learning',
    level: 'Level',
    notSet: 'Not set',
    autoCorrect: 'Auto-correction',
    autoCorrectHint: 'Automatically check your messages for mistakes.',
    showAnswerText: 'Show tutor replies as text',
    showAnswerTextHint: "Show the tutor's message right away instead of hiding it behind a tap.",
    reminders: 'Reminders',
    loadError: "Couldn't load settings. Please try again.",
  },
  ru: {
    sectionProfile: 'Профиль',
    name: 'Имя',
    nameRequired: 'Напиши имя',
    nameSaveError: 'Не получилось сохранить. Попробуй ещё раз.',
    save: 'Сохранить',
    sectionConnections: 'Подключения',
    telegramConnect: 'Подключить Telegram',
    telegramConnected: 'Telegram подключён',
    title: 'Настройки',
    sectionLanguage: 'Язык',
    interfaceLanguage: 'Язык интерфейса',
    english: 'English',
    russian: 'Русский',
    german: 'Deutsch',
    portuguese: 'Português',
    french: 'Français',
    spanish: 'Español',
    translationLanguage: 'Перевод и объяснения',
    translationLanguageHint: 'Используется для перевода реплик и объяснения ошибок.',
    sectionLearning: 'Обучение',
    level: 'Уровень',
    notSet: 'Не выбран',
    autoCorrect: 'Автоисправление',
    autoCorrectHint: 'Автоматически проверять свои реплики на ошибки.',
    showAnswerText: 'Показывать текст ответа',
    showAnswerTextHint: 'Показывать реплику репетитора сразу текстом, а не только по тапу.',
    reminders: 'Напоминания',
    loadError: 'Не получилось загрузить настройки. Попробуй ещё раз.',
  },
  de: {
    sectionConnections: 'Verbindungen',
    telegramConnect: 'Telegram verbinden',
    telegramConnected: 'Telegram verbunden',
    title: 'Einstellungen',
    sectionLanguage: 'Sprache',
    interfaceLanguage: 'Sprache der Oberfläche',
    english: 'English',
    russian: 'Русский',
    german: 'Deutsch',
    portuguese: 'Português',
    french: 'Français',
    spanish: 'Español',
    translationLanguage: 'Übersetzung und Erklärungen',
    translationLanguageHint: 'Wird für Übersetzungen der Nachrichten und Fehlererklärungen verwendet.',
    sectionLearning: 'Lernen',
    level: 'Niveau',
    notSet: 'Nicht festgelegt',
    autoCorrect: 'Autokorrektur',
    autoCorrectHint: 'Deine Nachrichten automatisch auf Fehler prüfen.',
    showAnswerText: 'Antworten des Tutors als Text zeigen',
    showAnswerTextHint: 'Die Nachricht des Tutors direkt als Text zeigen statt hinter einem Tipp verstecken.',
    reminders: 'Erinnerungen',
    loadError: 'Einstellungen konnten nicht geladen werden. Bitte versuch es noch einmal.',
  },
  pt: {
    sectionConnections: 'Conexões',
    telegramConnect: 'Conectar o Telegram',
    telegramConnected: 'Telegram conectado',
    title: 'Configurações',
    sectionLanguage: 'Idioma',
    interfaceLanguage: 'Idioma da interface',
    english: 'English',
    russian: 'Русский',
    german: 'Deutsch',
    portuguese: 'Português',
    french: 'Français',
    spanish: 'Español',
    translationLanguage: 'Tradução e explicações',
    translationLanguageHint: 'Usado para traduzir mensagens e explicar erros.',
    sectionLearning: 'Aprendizado',
    level: 'Nível',
    notSet: 'Não definido',
    autoCorrect: 'Correção automática',
    autoCorrectHint: 'Verificar automaticamente se há erros nas suas mensagens.',
    showAnswerText: 'Mostrar respostas do tutor em texto',
    showAnswerTextHint: 'Mostrar a mensagem do tutor em texto na hora, em vez de esconder atrás de um toque.',
    reminders: 'Lembretes',
    loadError: 'Não foi possível carregar as configurações. Tente de novo.',
  },
  fr: {
    sectionConnections: 'Connexions',
    telegramConnect: 'Connecter Telegram',
    telegramConnected: 'Telegram connecté',
    title: 'Réglages',
    sectionLanguage: 'Langue',
    interfaceLanguage: "Langue de l'interface",
    english: 'English',
    russian: 'Русский',
    german: 'Deutsch',
    portuguese: 'Português',
    french: 'Français',
    spanish: 'Español',
    translationLanguage: 'Traduction et explications',
    translationLanguageHint: 'Utilisée pour la traduction des messages et l’explication des erreurs.',
    sectionLearning: 'Apprentissage',
    level: 'Niveau',
    notSet: 'Non défini',
    autoCorrect: 'Correction automatique',
    autoCorrectHint: 'Vérifier automatiquement tes messages pour détecter les erreurs.',
    showAnswerText: 'Afficher les réponses du tuteur en texte',
    showAnswerTextHint: "Afficher tout de suite le message du tuteur en texte au lieu de le cacher derrière un appui.",
    reminders: 'Rappels',
    loadError: 'Impossible de charger les réglages. Réessaie.',
  },
  es: {
    sectionConnections: 'Conexiones',
    telegramConnect: 'Conectar Telegram',
    telegramConnected: 'Telegram conectado',
    title: 'Ajustes',
    sectionLanguage: 'Idioma',
    interfaceLanguage: 'Idioma de la interfaz',
    english: 'English',
    russian: 'Русский',
    german: 'Deutsch',
    portuguese: 'Português',
    french: 'Français',
    spanish: 'Español',
    translationLanguage: 'Traducción y explicaciones',
    translationLanguageHint: 'Se usa para traducir mensajes y explicar errores.',
    sectionLearning: 'Aprendizaje',
    level: 'Nivel',
    notSet: 'Sin definir',
    autoCorrect: 'Corrección automática',
    autoCorrectHint: 'Comprobar automáticamente si tus mensajes tienen errores.',
    showAnswerText: 'Mostrar las respuestas del tutor en texto',
    showAnswerTextHint: 'Mostrar el mensaje del tutor en texto de inmediato en vez de esconderlo tras un toque.',
    reminders: 'Recordatorios',
    loadError: 'No se pudieron cargar los ajustes. Inténtalo de nuevo.',
  },
};
